import React, { useContext } from 'react'
import { PluginContext } from '@flamingo_tech/funkgo'

import Pressable from '../../common/Pressable/Pressable'
import styles from './QuantityChooser.module.css'
import cx from '../../../utils/className'

const [SUBTRACT, ADD] = ['SUBTRACT', 'ADD']

const QuantityChooser = props => {
  const plugin = useContext(PluginContext)
  const { $i18n } = plugin

  const maxQuantity = props.maxQuantity ? props.maxQuantity : Infinity
  const minQuantity = props.minQuantity !== undefined ? props.minQuantity : 1

  const handleQuantityChange = (ev, operator) => {
    ev.preventDefault()
    const prevQuantity = props.quantity
    const currentQuantity = operator === SUBTRACT ? (prevQuantity > minQuantity ? prevQuantity - 1 : minQuantity) : (prevQuantity < maxQuantity ? prevQuantity + 1 : prevQuantity)

    props.onChange && props.onChange(currentQuantity)
  }

  return (
    <div className={cx(styles.wrapper, props.isDesktop && styles.isDesktop)}>
      <Pressable
        className={styles.leftBtn}
        onClick={ev => handleQuantityChange(ev, SUBTRACT)}
        ariaLabel={$i18n.transl('core.cart.decreaseQty')}
      >
        <span aria-hidden="true">-</span>
      </Pressable>
      <div className={styles.quantity}><span>{props.quantity}</span></div>
      <Pressable
        className={styles.rightBtn}
        onClick={ev => handleQuantityChange(ev, ADD)}
        ariaLabel={$i18n.transl('core.cart.increaseQty')}
      >
        <span aria-hidden="true">+</span>
      </Pressable>
    </div>
  )
}

export default QuantityChooser
